import { render } from "./PurchaseOrdersMac.vue?vue&type=template&id=45a05064&scoped=true&ts=true&lang=pug"
import script from "./PurchaseOrdersMac.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrdersMac.vue?vue&type=script&lang=ts"

import "./PurchaseOrdersMac.vue?vue&type=style&index=0&id=45a05064&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a05064"]])

export default __exports__